import * as initializers0 from '../initializers/input_components/datetimepicker.js'; import * as initializers1 from '../initializers/input_components/general_event_toggle.js'; import * as initializers2 from '../initializers/input_components/input_mask.js'; import * as initializers3 from '../initializers/input_components/radio_buttons.js'; import * as initializers4 from '../initializers/input_components/switchery.js'; import * as initializers5 from '../initializers/input_components/tom_select.js'; import * as initializers6 from '../initializers/input_components/tooltips.js'; let initializers = [initializers0, initializers1, initializers2, initializers3, initializers4, initializers5, initializers6];

let CocoonLoader = function() {
  $('body').on('cocoon:after-insert', (e, item) => {
    if (initializers == undefined) { return };

    initializers.forEach((initializer) => {
      // Isolate each initializer - one throwing (e.g. a plugin that failed to
      // register on this jQuery instance) must not stop the rest of the list
      // from running.
      try {
        initializer.default(this);
      } catch (error) {
        console.error('[cocoon] input_components initializer failed:', error);
      }
    });
  })
};

export default CocoonLoader;
